<script setup lang="ts">
import XIcon from '@/assets/icons/XIcon.vue';

type Action = { label: string; onClick: () => Promise<void> | void } | undefined;

const props = defineProps<{
  message: string;
  action?: Action;
  closeLabel?: string;
  onClose?: () => void;
}>();

const handleAction = async (): Promise<void> => {
  if (!props.action) return;
  try {
    await props.action.onClick();
  } catch (error) {
    console.error(error);
  }
};

const handleClose = (): void => {
  props.onClose?.();
};
</script>

<template>
  <div class="flex items-center gap-md text-left">
    <span class="min-w-0 [overflow-wrap:anywhere]">{{ props.message }}</span>

    <button
      v-if="props.action"
      class="ml-auto appearance-none rounded-full border border-current bg-transparent px-lg py-xs font-bold text-current cursor-pointer"
      type="button"
      @click.stop="handleAction"
    >
      {{ props.action.label }}
    </button>

    <button
      v-if="props.onClose"
      class="appearance-none border-0 bg-transparent p-xs text-current cursor-pointer flex"
      type="button"
      :aria-label="props.closeLabel"
      @click.stop="handleClose"
    >
      <XIcon class="size-icon-sm" />
    </button>
  </div>
</template>
